import { render, staticRenderFns } from "./CaseNoteQuarantineDialog.vue?vue&type=template&id=2046f56b&"
import script from "./CaseNoteQuarantineDialog.vue?vue&type=script&lang=js&"
export * from "./CaseNoteQuarantineDialog.vue?vue&type=script&lang=js&"
import style0 from "./CaseNoteQuarantineDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardTitle,VCol,VDialog,VDivider,VListItemSubtitle,VListItemTitle,VRow,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2046f56b')) {
      api.createRecord('2046f56b', component.options)
    } else {
      api.reload('2046f56b', component.options)
    }
    module.hot.accept("./CaseNoteQuarantineDialog.vue?vue&type=template&id=2046f56b&", function () {
      api.rerender('2046f56b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AccountPage/NotesCardBlock/components/CaseNoteQuarantineDialog.vue"
export default component.exports